import { getBrandConfig } from '@checkout/brands'

// Get brand ID from environment variable
const brandId = import.meta.env.VITE_BRAND_ID ?? 'vigilkids'

// Load brand configuration
export const brandConfig = getBrandConfig(brandId)

// Export for convenience
export { brandId }
